import $http from '@/api';

const getContent = async ({ type, id }) => {
  if (!type || !id) return null;
  return $http.get(`/api/content/${type}/${id}`);
};

const search = async (filters = {}) => $http.post('/api/content/search', filters);

export default {
  getContent,
  search,
};
